import { inboxState } from '../../../modules/InboxModule/state';
import { tasksState } from '@modules/TasksModule/state';
import { phoneState } from '@modules/SoftPhoneModule/state';

/**
 * Computes the active call SID for the currently selected task.
 * This function only executes when called, making it perfect for on-demand computation.
 *
 * @returns The session ID if all conditions are met and the call is active, otherwise undefined
 */
export function getActiveCallSid(): string | undefined {
  const selectedTaskId = inboxState.selectedTaskId;

  if (!selectedTaskId) {
    return undefined;
  }

  const task = tasksState.tasks[selectedTaskId];

  if (!task || task.id !== task.attributes.sessionSid) {
    return undefined;
  }

  const callId = task.attributes?.callId;
  if (!callId) {
    return undefined;
  }

  const call = phoneState.callList.find((c) => c.callId === callId);
  const isCallActive = call && (call.established || call.hasSession);

  return isCallActive ? task.id : undefined;
}
